<template>
  <div>
    <Head title="Vytvořit kalkulaci - Ohřev vody" />
    <h1 class="mb-8 text-3xl font-bold">
      <!-- <Link class="text-indigo-400 hover:text-indigo-600" href="/components">Kalkulace</Link> -->
      <!-- <span class="text-indigo-400 font-medium">/</span> Kalkulace -->
      Kalkulace Ohřev vody
    </h1>
    <!-- <div class="mb-4 p-4 text-red-800 bg-red-300 border border-red-800 rounded"><strong>POZOR:</strong> Prozatím testovací mód výpočtu!</div>
    <div class="mb-4 p-4 text-indigo-800 bg-indigo-300 border border-indigo-800 rounded">
      <strong>INFO:</strong><br />
      <ul class="pl-5 list-disc">
        <li>Pomocí setu zvolíte střídač.</li>
        <li>U obou střídačů lze nyní zvolit větší bojler na 200l s příplatkem.</li>
        <li>Pokud nezvolíte boiler, sníží se dotace na 60 000 Kč.</li>
        <li>SUMWAYTECH zvládne až 8 panelů (nad 5 s příplatkem) a baterii.</li>
        <li>GETI zvládne 6 panelů (nad 5 s příplatkem).</li>
      </ul>
    </div> -->
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form ref="formref" @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <!-- <div class="mt-4 w-full">
            <h2 class="mb-4 text-2xl font-bold">Zákazník</h2>
          </div>

          <text-input v-model="form.case_code" :error="form.errors.case_code" class="pb-6 pr-6 w-full lg:w-1/2" label="Číslo obchodního případu" /> -->

          <div class="mt-4 w-full">
            <div class="flex gap-2 items-center">
              <h2 class="text-2xl font-bold">Ohřev vody</h2>
              <select-input v-model="form.version" class="w-auto">
                <option :value="null" selected>Aktuální verze</option>
                <option :value="'31052024'">Do 31.5.2024</option>
              </select-input>
            </div>
            <div v-if="sets.length !== 0" class="flex gap-2 items-center mt-8 w-full">
              <select-input v-model="form.set_id" class="pb-8 pr-6 w-full lg:w-1/3" label="* Vyberte set" @change="setChanged">
                <option :value="null" disabled selected>Vyberte set</option>
                <option v-for="set in sets" :key="set.id" :value="set.id">{{ set.name }}</option>
              </select-input>
              <div v-if="form.set_id" class="flex mb-4 p-4 w-full h-full bg-indigo-100 lg:w-1/3">
                <div class="font-bold">Výkon FVE</div>
                <div class="ml-auto">{{ fvePower }} kWp</div>
              </div>
              <div v-if="form.set_id" class="flex mb-4 p-4 w-full h-full bg-indigo-100 lg:w-1/3">
                <div class="font-bold">Kapacity FVE</div>
                <div class="ml-auto">{{ fveCapacity }} kWh</div>
              </div>
            </div>
            <div class="mb-4 w-full overflow-x-auto">
              <table v-if="form.components.length !== 0" class="w-full whitespace-nowrap">
                <thead>
                  <tr class="text-left font-bold">
                    <th class="pb-4 pt-6">Komponenty</th>
                    <th class="pb-4 pt-6 px-6">Počet (ks)</th>
                    <!-- <th class="pb-4 pt-6 px-6 text-right">Cena/ks</th>
                    <th class="pb-4 pt-6 px-6 text-right">Celkem</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="component in form.components" :key="component.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="py-2 text-sm border-t">{{ component.name }}</td>
                    <td class="px-6 text-sm border-t">
                      <text-input v-if="component.editable" v-model="component.quantity" type="number" :min="component.min" :max="component.max" required step="any" class="form-input-sm w-full" @change="component.type == 'panel' || component.type == 'battery' || component.type == 'inverter' ? preCalculateRules() : ''" />
                      <span v-else>{{ component.quantity }}</span>
                    </td>
                    <!-- <td class="px-6 text-right text-sm border-t">{{ $filters.currency(component.unit_price) }}</td>
                    <td class="px-6 text-right text-sm border-t">{{ $filters.currency(component.unit_price * component.quantity) }}</td> -->
                  </tr>
                  <tr v-if="form.discount_type == 'battery'" class="text-green-600">
                    <td class="py-2 text-sm border-t">Baterie zdarma</td>
                    <td class="px-6 text-sm border-t"><span>1</span></td>
                    <td class="px-6 text-right text-sm border-t">0 Kč</td>
                    <td class="px-6 text-right text-sm border-t">0 Kč</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="form.set_id" class="-mr-6 mb-4 p-8">
          <label class="inline-flex items-center pb-4 pr-6 w-full lg:w-auto"><input v-model="form.isLight" class="mr-2" type="checkbox" />Klient má nárok na NZÚ Light</label><br />
          <label class="inline-flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.favored_region" class="mr-2" type="checkbox" />Zvýhodněný kraj</label><br />
          <!-- <label class="inline-flex items-center mt-4 pb-4 pr-6 w-full lg:w-auto"><input v-model="form.with_insulation" class="mr-2" type="checkbox" />V kombinaci se zateplením - sleva</label> -->
          <label class="hidden inline-flex items-center pb-4 pr-6 w-full lg:w-auto"><input v-model="form.inCombination" class="mr-2" type="checkbox" />Bude v kombinaci k fotovoltaice</label>
          <div v-if="form.inCombination" class="mb-5 mt-2 p-5 bg-orange-200 rounded"><strong>Zapište si někam cenu bez DPH</strong> - tu po vygenerování přílohy vložte jako částku za ohřev vody v klasické kalkulaci.</div>
          <loading-button :loading="calculating" class="btn-indigo" @click.prevent="calculate(false)">Přepočítat</loading-button>
          <div v-if="calculated">
            <div class="mt-6 w-full">
              <h2 class="mb-6 text-2xl font-bold">Kalkulace</h2>
            </div>
            <div class="flex">
              <div class="mb-4 ml-auto mr-8 w-full">
                <div class="flex p-4 font-bold bg-gray-100">
                  <div class="">Celkem bez DPH</div>
                  <div class="ml-auto">{{ $filters.currency(price) }}</div>
                </div>

                <div class="flex mt-4 p-4 font-bold bg-gray-100">
                  <div class="">Celkem s DPH</div>
                  <div class="ml-auto">{{ $filters.currency(priceWithTax) }}</div>
                </div>
                <div class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">DPH</div>
                  <div class="ml-auto">{{ $filters.currency(tax) }}</div>
                </div>
                <div v-if="subsidy != 0" class="flex p-4 py-2 text-sm bg-gray-100">
                  <div class="">Dotace</div>
                  <div class="ml-auto">{{ $filters.currency(subsidy) }}</div>
                </div>
                <div v-if="subsidy != 0" class="flex mt-4 p-4 font-bold bg-green-200">
                  <div>Celkem s DPH a dotací</div>
                  <div class="ml-auto">{{ $filters.currency(totalPrice) }}</div>
                </div>
              </div>
            </div>
            <text-input v-model="form.case_code" :error="form.errors.case_code ? form.errors.case_code[0] : form.errors.case_code" class="pb-6 pr-6 w-full lg:w-1/3" label="Číslo obchodního případu" />
          </div>
        </div>

        <div v-if="calculated" class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <text-input v-if="!form.inCombination" v-model="signedDate" :error="form.errors.signedDate" class="pb-6 pr-6 w-full lg:w-1/4" label="Datum podpisu" />
          <text-input v-if="!form.inCombination" v-model="signedIn" :error="form.errors.signedIn" class="pb-6 pr-6 w-full lg:w-1/4" label="Místo podpisu" />
          <loading-button :loading="calculating" class="btn-indigo" @click.prevent="calculate(true)">Vygenerovat PDF</loading-button>
        </div>
        <div class="flex hidden items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit" @click.prevent>Odeslat</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, usePage } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
// import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
    // TextAreaInput,
  },
  layout: Layout,
  props: {
    sets: Array,
    components: Array,
    todayDate: String,
    owner: Boolean,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        version: null,
        //fve
        set_id: null,
        isLight: true,
        inCombination: false,
        with_insulation: false,
        components: this.components,
        favored_region: false,
        case_code: null,
        //Svj
      }),
      initialUrl: this.$page.url,
      regions: ['Hlavní město Praha', 'Středočeský kraj', 'Jihočeský kraj', 'Plzeňský kraj', 'Karlovarský kraj', 'Ústecký kraj', 'Liberecký kraj', 'Královéhradecký kraj', 'Pardubický kraj', 'Kraj Vysočina'],
      calculated: false,
      calculating: false,
      //prices
      price: 0,
      discountedPrice: 0,
      salesmanDiscount: 0,
      wallboxDiscount: 0,
      tax: 0,
      priceWithTax: 0,
      subsidy: 0,
      totalPrice: 0,
      fvePower: 0,
      fveCapacity: 0,
      signedIn: 'Praha',
      signedDate: this.todayDate,
    }
  },
  methods: {
    store() {
      this.form.post('/sets')
    },
    setChanged() {
      this.$nextTick(() => {
        this.$inertia.get(
          '/calculations-light/create',
          {
            set_id: this.form.set_id,
          },
          {
            preserveState: true,
            preserveScroll: true,
            replace: false,
            only: ['components'],
            onSuccess: () => {
              this.form.components = this.components
              this.preCalculateRules()
              this.calculate(false)
              //odebrání parametru set_id z url
              this.$inertia.get(this.initialUrl, {}, { replace: true, preserveScroll: true, preserveState: true })
            },
          },
          {},
        )
      })
    },
    componentsPrice() {
      let price = 0
      this.form.components.forEach((component) => {
        price += component.unit_price * component.quantity
      })
      return price
    },
    componentsPriceWithoutProject() {
      let price = 0
      this.form.components.forEach((component) => {
        if (component.type != 'project') price += component.unit_price * component.quantity
      })
      return price
    },
    calculate(needPdf = false) {
      //check if amount discount is not higher than 10% price
      let price = this.componentsPrice()
      let maxAmountPrice = this.owner ? price * 0.5 : price * 0.23
      if (this.form.discount_type == 'amount' && this.form.discount > maxAmountPrice) {
        //alert('Sleva nemůže být vyšší než 15% (' + price * 0.10 + ') z ceny komponentů.')
        this.$refs.discountAmount.$el.querySelector('input').setAttribute('max', maxAmountPrice)
        this.calculating = false
      }

      //accept only 1 boiler count from component.type == boiler
      let boilerCount = 0
      this.form.components.forEach((component) => {
        if (component.type == 'boiler') {
          boilerCount = boilerCount + parseInt(component.quantity)
        }
      })

      if (boilerCount > 1) {
        alert('Lze vybrat maximálně jeden Bojler')
        this.calculating = false
        return false
      }

      //if isLight is not checked, we need 1 boiler (only if not admin)
      // if (usePage().props.value.auth.user.owner !== true) {
      //   if (!this.form.isLight && boilerCount == 0) {
      //     alert('Pokud klient nemá nárok na NZÚ Light, je NUTNÉ VYBRAT BOJLER. V případě, že klient nechce bojler, kontakujte zřizovatele aplikace.')
      //     this.calculating = false
      //     return false
      //   }
      // }

      //validate form
      if (!this.$refs.formref.checkValidity()) {
        this.$refs.formref.reportValidity()
        return false
      }

      //validate signedIn
      if (needPdf && this.signedIn.length == 0) {
        alert('Místo podpisu musí být vyplněno.')
        return false
      }

      this.calculating = true

      this.$nextTick(() => {
        axios
          .post('/calculations-light/calculate', {
            version: this.form.version,
            set_id: this.form.set_id,
            components: this.form.components,
            isLight: this.form.isLight,
            inCombination: this.form.inCombination,
            with_insulation: this.form.with_insulation,
            needPdf: needPdf,
            favored_region: this.form.favored_region,
            signedIn: this.signedIn,
            case_code: this.form.case_code,
            signedDate: this.signedDate,
          })
          .then((response) => {
            //console.log(response.data)
            this.price = response.data.price
            this.tax = response.data.tax
            this.priceWithTax = response.data.priceWithTax
            this.subsidy = response.data.subsidy
            this.totalPrice = response.data.totalPrice
            // this.fvePower = response.data.fvePower
            this.calculated = true
            if (response.data.pdf) {
              this.downloadFile(response.data.pdf)
              //window.open(response.data.pdf, '_blank')
            }
          })
          .catch((error) => {
            this.form.errors = error.response.data.errors
            if (this.form.errors && this.form.errors['case_code']) {
              this.form.errors['case_code'][0] = 'Číslo OP je povinné.'
            }
          })
          .finally(() => {
            this.calculating = false
          })
      })
    }, //end calculate
    //get fve power from components panels by pow_cap
    preCalculateRules() {
      let fvePower = 0
      let fveCapacity = 0
      let panelsCount = 0
      let batteryCount = 0
      let inverterCount = 0
      this.form.components.forEach((component) => {
        if (component.type == 'panel') {
          fvePower = fvePower + component.quantity * component.power_cap
          panelsCount = panelsCount + parseInt(component.quantity)
        }
        if (component.type == 'battery') {
          fveCapacity = fveCapacity + component.quantity * component.power_cap
          batteryCount = batteryCount + parseInt(component.quantity)
        }
      })
      this.form.components.forEach((component) => {
        if (component.type == 'inverter') {
          //retype to int
          inverterCount = inverterCount + parseInt(component.quantity)
        }
      })

      if (!this.canBatteryFree() && this.form.discount_type == 'battery') {
        this.form.discount_type = 'percent'
      }

      //add 10 kWh to battery capacity if battery discount is selected + battery count
      if (this.form.discount_type == 'battery') {
        fveCapacity = fveCapacity + 10
        batteryCount = batteryCount + 1
      }

      //custom project price for company
      // this.$nextTick(() => {
      //   this.companyProjectPrice()
      // })

      this.fvePower = fvePower.toFixed(2)
      this.fveCapacity = fveCapacity.toFixed(2)
      this.fillConstruction()
      //this.fillInstalation()
      //this.fillShipping()
      //this.fillCables()
      //this.fillPhotovoltaicSwitchboard(inverterCount)
      //this.fillConnectors(panelsCount)
      //this.fillBatterySwitchboard(batteryCount, inverterCount)
      return fvePower
    },
    fillConstruction() {
      this.form.components.forEach((component) => {
        if (component.type == 'construction') {
          if (this.fvePower <= 2.75) {
            component.quantity = 2.75
          } else {
            component.quantity = this.fvePower
          }
        }
      })
    },
    fillInstalation() {
      this.form.components.forEach((component) => {
        if (component.type == 'instalation') {
          if (this.fvePower > 10) {
            component.quantity = (this.fvePower / 10).toFixed(2)
          } else {
            component.quantity = 1
          }
        }
      })
    },
    fillShipping() {
      this.form.components.forEach((component) => {
        if (component.type == 'shipping') {
          if (this.fvePower > 10) {
            component.quantity = (1 + (this.fvePower - 10) / 2 / 10).toFixed(4)
          } else {
            component.quantity = 1
          }
        }
      })
    },
    fillCables() {
      this.form.components.forEach((component) => {
        if (component.type == 'cables') {
          if (this.fvePower > 10) {
            component.quantity = Math.floor(this.fvePower / 10) * 200
          } else {
            component.quantity = 200
          }
        }
      })
    },
    fillPhotovoltaicSwitchboard(inverterCount = 0) {
      //sum all inverter count
      this.form.components.forEach((component) => {
        if (component.type == 'photovoltaic_switchboard') {
          component.quantity = inverterCount
        }
      })
    },
    // fillConnectors(panelsCount = 0) {
    //   this.form.components.forEach((component) => {
    //     if (component.type == 'connectors') {
    //       component.quantity = panelsCount
    //       //1 connector for 2 panels
    //       if (component.quantity % 2 == 0) {
    //         component.quantity = component.quantity / 2
    //       } else {
    //         component.quantity = (component.quantity + 1) / 2
    //       }
    //     }
    //   })
    // },
    fillBatterySwitchboard(batteryCount = 0, inverterCount = 0) {
      this.form.components.forEach((component) => {
        if (component.type == 'battery_switchboard') {
          if (batteryCount > inverterCount * 2) {
            component.quantity = 1
          } else {
            component.quantity = 0
          }
        }
      })
    },

    downloadFile(file) {
      let element = document.createElement('a')
      element.setAttribute('href', file.url)
      element.setAttribute('download', file.name)
      document.body.appendChild(element)
      element.click()
    },

    canBatteryFree() {
      if (this.form.components.length > 0) {
        let battery = this.form.components.find((component) => component.type == 'battery')
        if (battery) {
          if (battery.quantity > 0) {
            return true
          }
        }
      }
      return false
    },

    companyProjectPrice() {
      let project = this.form.components.find((component) => component.type == 'project')

      if (this.form.subject == 'company') {
        if (this.projectDefaultPrice == 0) {
          this.projectDefaultPrice = project.unit_price
        }

        let componentsPrice = this.componentsPriceWithoutProject()
        project.unit_price = componentsPrice * 0.11111111111111
      } else {
        //return back old price
        if (this.projectDefaultPrice != 0) project.unit_price = this.projectDefaultPrice
      }
    },

    changeDiscountType() {
      this.form.discount = 0
      this.preCalculateRules()
    },

    changeSubject() {
      this.preCalculateRules()
    },
  },
}
</script>
